import {
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiMessageSquare } from "react-icons/fi";

export const CommentPopover = ({ comment }: { comment: string }) => {
  const { t } = useTranslation();
  return (
    <Popover placement="bottom" isLazy>
      <PopoverTrigger>
        <IconButton aria-label={t("Comment")} icon={<FiMessageSquare />} size="xs" variant="ghost" color="smPrimary" />
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverBody>
          <Text fontSize="sm" whiteSpace="pre-wrap" color="smText">
            {comment}
          </Text>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
